export default "__VITE_ASSET__CYre_pos__"